import { AfterViewInit, Component, ElementRef, HostListener, Injector, OnChanges, OnDestroy, OnInit, SimpleChanges, ViewChild } from '@angular/core';
import { FormControl } from '@angular/forms';
import { Observable, Subscription } from 'rxjs';
import { BaseComponent } from 'src/app/common/base/base.component';
import { DocumentType } from 'src/app/services/documents/documents';
import { DocumentTypeListComponent } from './document-type-list/document-type-list.component';
import { DocumentsService } from 'src/app/services/documents/documents.service';

@Component({
  selector: 'app-document-type',
  templateUrl: './document-type.component.html',
  styleUrls: ['./document-type.component.scss']
})
export class DocumentTypeComponent extends BaseComponent implements OnInit, OnDestroy, OnChanges, AfterViewInit {

  @ViewChild(DocumentTypeListComponent) side?: DocumentTypeListComponent;

  disabled: boolean = false;

  resourceRequired: boolean = false;

  filterCtrl = new FormControl();

  errorMessages: string[] = [];
  headerOnTop: boolean = false;

  valueFilter!: string;
  createdOn!: string;

  ///////
  tmpFilter!: string;
  condition!: string;
  filteredFilter: any[] = [];
  currentFilter: any;
  filter: any;

  loadingMessage!: string;

  showAmendmentToggle: boolean = false;
  //////

  documentType?: DocumentType;
  documentTypes?: DocumentType[];
  documentTypes$!: Observable<DocumentType[]>;
  documentTypesSubs!: Subscription;

  private resizeTimer: any;

  constructor(
    protected override injector: Injector,
    public service: DocumentsService
  ) {
    super(injector);
  }

  ngAfterViewInit(): void {
    this.setHeights(64);
  }

  ngOnChanges(changes: SimpleChanges): void {
  }

  ngOnInit() {
    this.moduleTitle = 'Document Type Catalog';
    this.loadDocumentTypes();
  }

  override ngOnDestroy(): void {
    this.documentTypesSubs?.unsubscribe();
    super.ngOnDestroy();
  }

  loadDocumentTypes() {
    this.documentTypes$ = this.store.select(state => state.DocumentType.data);
    this.documentTypesSubs = this.documentTypes$.subscribe(data => {
      if (data?.length) {
        this.documentTypes = data;
        if (this.documentType) {
          const documentType = this.documentTypes.find(x => x.id == this.documentType?.id);
          if (documentType) {
            this.documentType = documentType;
            this.documentType.documentTemplateId = this.documentTypes.find(x => x.type === this.documentType?.id)?.id;
          }
        }
      }
    });
  }

  clear() {
    this.errorMessages = [];
  }

  selectedRow(e: DocumentType) {
    this.documentType = e;
  }

  create() {
    this.side?.createDocumentType();
  }

  @HostListener("window:resize")
  onResize() {
    clearTimeout(this.resizeTimer);
    this.resizeTimer = setTimeout(() => {
      this.innerWidth = window.innerWidth;
      if (this.innerWidth < 768) {
        this.isExpanded = false;
      }
    }, 200);
  }

  //////
  changedFilter() { }
  clearFilter() { }
  selectedFilter() { }
  createDisabled() { }
  editDisabled() { }
  action() { }

  applyFilter(e: any) {
    if (!e)
      this.valueFilter = '';
    this.filter = e;
  }


}

